module.exports = __webpack_public_path__ + "static/media/icon-burger.03739da6.svg";